<template>
  <svg
    width="17"
    height="17"
    viewBox="0 0 17 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      class="stroke"
      x="0.5"
      y="0.5"
      width="15.0563"
      height="15.0563"
      rx="1.28403"
      stroke="none"
    />
    <path
      class="fill"
      d="M4.18005 11.198C4.08053 11.198 4.00009 11.1168 4.00009 11.0168C3.9966 10.5099 4.10019 10.0081 4.30388 9.5445C4.49629 9.07721 4.78218 8.65481 5.14361 8.3036C6.76622 6.83051 9.23184 6.83051 10.8546 8.3036C11.2161 8.6548 11.502 9.07721 11.6946 9.5445C11.8983 10.0081 12.0019 10.5099 11.9984 11.0168C11.9984 11.1166 11.9177 11.1976 11.8186 11.1976L4.18005 11.198Z"
      fill="none"
    />
  </svg>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "PremiumIcon",
});
</script>

<style scoped lang="scss">
.fill {
  @include transition(fill 100ms ease-out);
  @include themed() {
    fill: t($secondary);
  }
}
.stroke {
  @include transition(stroke 100ms ease-out);
  @include themed() {
    stroke: t($secondary);
  }
}
</style>
